<template>
  <div class="apparent_depth">
    <v-speed-dial
      v-model="fab"
      top
      right
      direction="bottom"
      :open-on-hover="hover"
      :transition="transition"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="green lighten-1" dark fab>
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-file
          </v-icon>
        </v-btn>
      </template>
      <v-tooltip left color="green">
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab dark small color="green" v-bind="attrs" v-on="on" @click="openSetupDialog(); getSetupPhoto()">
            <v-icon> mdi-image-search </v-icon>
          </v-btn>
        </template>
        <span>Setup Photo</span>
      </v-tooltip>

      <v-tooltip left color="indigo">
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab dark small color="indigo" v-bind="attrs" v-on="on" @click="getLabManual">
            <v-icon>mdi-file-document</v-icon>
          </v-btn>
        </template>
        <span>Lab Maunal</span>
      </v-tooltip>

      <!--v-btn v-if="(current.user_level=='INCHARGE' || current.user_level=='ADMIN') && checkEnd" fab dark small color="red lighten-2" @click="changeCheck">
        <v-icon>mdi-timer-off</v-icon>
      </v-btn>      
      <v-btn v-if="(current.user_level=='INCHARGE' || current.user_level=='ADMIN') && !checkEnd" fab dark small color="light-green darken-1" @click="changeCheck">
        <v-icon>mdi-timer</v-icon>
      </v-btn>
      <v-btn v-if="(current.user_level=='INCHARGE' || current.user_level=='ADMIN') && override==0" fab dark small color="red lighten-2" @click="setExperimentOverrideOn">
        <v-icon>mdi-key</v-icon>
      </v-btn>
      <v-btn v-if="(current.user_level=='INCHARGE' || current.user_level=='ADMIN') && override==1" fab dark small color="light-green darken-1" @click="setExperimentOverrideOff">
        <v-icon>mdi-key-remove</v-icon>
      </v-btn-->
      
    </v-speed-dial>
    <v-row>
      <ExperimentTitle />
    </v-row>
    <v-row>
      <v-col xs="12" sm="4">
        <v-card>
          <v-card-text>
            <v-img
              class="clickable"
              :src="api.camera_1.url"
              @click="popCamera(api.camera_0)"
            >
              <template v-slot:default> {{ experiment.camera.camera_1_text }}Camera 1 </template>
            </v-img>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-text>
            <v-img
              class="clickable"
              :src="api.camera_2.url"
              @click="popCamera(api.camera_2)"
            >
              <template v-slot:default> Camera 2 </template>
            </v-img>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col xs="12" sm="8">
        <v-expansion-panels v-model="controlPanel" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header color="green lighten-5">
              <h5>Control</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="control-content">
              <v-card class="p-3">
                <v-overlay absolute :value="loop_flag || loading">
                  <v-btn color="primary">
                    Operating
                    <v-progress-circular
                      indeterminate
                      size="12"
                      class="ma-4"
                    ></v-progress-circular>
                  </v-btn>
                </v-overlay>
                <v-row no-gutters>
                  <v-col cols="3">
                    <v-subheader> 
                      <strong>Slit Position<br>0-300</strong>
                    </v-subheader>
                  </v-col>
                  <v-col  cols="9">
                    <v-slider
                      class="mt-4"
                      v-model="M_M1"
                      :max="300"
                      thumb-label="always"
                      @change="clientAction('setCommand', 'device_1', 'M_M1MOVE|'+M_M1);"
                      :disabled="( // lock user when hold, lock ic and admin when active
                        (((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false)
                        ||
                        ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false)
                        )"
                    ></v-slider>
                  </v-col>
                </v-row>
                <v-row class="mt-3" no-gutters>
                  <v-col>
                    <div class="d-flex justify-end">
                    <v-btn class="ma-6" @click="clientAction('setChart', 'device_1','MEASURE|'+20)"
                      :disabled="(
                        S_M1+scan_distance > 1800) || 
                        (((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false)
                        ||
                        ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false
                        )"
                    >
                      Measure
                    </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header color="green lighten-5">
              <h5>Measure Result</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <apexchart
                type="line"
                :options="options"
                :series="series"
                ref="realtimeChart"
              >
              </apexchart>
              <v-overlay absolute :value="loop_flag || loading">
                <v-btn color="primary">
                  Operating
                  <v-progress-circular
                    indeterminate
                    size="12"
                    class="ma-4"
                  ></v-progress-circular>
                </v-btn>
              </v-overlay>             
            </v-expansion-panel-content>            
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <CameraDialog v-model="camera_dialog" :camera="camera_dialog_camera" />
    <v-dialog v-model="dialog_setup" max-width="800px">
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeSetupDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Experiment Setup</v-toolbar-title>
          <!--v-spacer></v-spacer-->
        </v-toolbar>
        <v-carousel v-model="model">
          <v-carousel-item
            v-for="(item,i) in setup_photos"
            :key="i"
            :src="item.src"
          >
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_setup" max-width="800px">
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeSetupDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Experiment Setup</v-toolbar-title>
          <!--v-spacer></v-spacer-->
        </v-toolbar>
        <v-carousel v-model="model">
          <v-carousel-item
            v-for="(item,i) in setup_photos"
            :key="i"
            :src="item.src"
          >
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ExperimentTitle from "@/components/ExperimentTitle.vue";
import CameraDialog from "@/components/CameraDialog.vue";
import ExperimentBasic from "@/services/iot/api_basic_experiment";
import json from '@/../storage/data.json'
export default {
  name: "interference",
  components: {
    ExperimentTitle,
    CameraDialog,    
  },
  mixins: [ExperimentBasic],
  data: function () {
    return {
      controlAuth: true,
      model: 0,
      dialog_setup: false,
      checkEnd: true,
      direction: 'bottom',
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: true,
      right: true,
      bottom: false,
      left: false,
      transition: 'slide-y-reverse-transition',
      current: {
        username: null,
        user_level: "USER",
        school_id: null,
        auth_token: null,
        experiment: null,
        equipment_id: null,
        booking_id: null,
      },
      controlPanel: [0, 1],
      realTimePanel: 0,
      camera1_url: null,
      camera2_url: null, 
      inte: null,
      M_M1: 0,
      loading: false,
      loop_flag: false,
      distance: 0,
      setup_photos: [],
      api: {
        value: "",
        value_got_at: null,
        value_set_at: null,
        camera_1: "",
        camera_2: "",
      },
      options: {
        width: "100%",
        stroke: {
          width: 1,
        },
        yaxis: {
          title: {
            text: "Intensity (arbitrary unit)",
          },
        },
        xaxis: {
          type: 'numeric',
          title: {
            text: "Distance (mm)",
          },
          tickAmount: 10,
          labels: {
            formatter: function(val) {
              return parseFloat(val).toFixed(1);
            }
          }
        },
      },
      series: [
        {
          data: [

          ],
        },
      ],
    };
  },
  mounted: function () {    
    var self = this;
    self.checkEnd = self.$parent.checkEnd;
    self.current.school_id = self.$store.state.user.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    self.school_id = self.$route.params.school_id;
    self.experiment = self.$route.query.experiment;
    self.equipment_id = self.$route.query.equipment;
    self.getValue("camera_1", function () {
      self.api.camera_1 = self.api.value;
      self.getValue("camera_2", function () {
        self.api.camera_2 = self.api.value;
        self.getValue("device_1", function () {
          self.M_M1 = self.api.value.M_M1;
        });
      });
    });
    self.checkOverrided();
    setInterval(function () {
      //loop distance value
      if (self.loop_flag) {
        self.getValue("device_1", function () {
          if (self.api.value_set_at >= self.api.command_set_at) {
            self.loop_flag = false;
            self.M_M1 = self.api.value.M_M1;
          }
        });
      }
    }, 1000);
    self.experiment_name = "APPARENT_DEPTH";    
  },
  methods: {    
    openSetupDialog(){
      var self = this;
      self.dialog_setup = true;
    },
    closeSetupDialog(){
      var self = this;
      self.dialog_setup = false;
    },
    changeCheck(){
      var self = this;
      self.$emit("changeCheck");
      self.checkEnd = self.$parent.checkEnd;
    },
    tmp(a){
      alert(a);
    },
  },
};
</script>
<style>
  /* This is for documentation purposes and will not be needed in your application */
  .v-speed-dial {
    position: absolute;
    z-index: 2;
  }

  .v-btn--floating {
    position: relative;
    z-index: 5;
  }
  
  .control-content>.v-expansion-panel-content__wrap{
    padding: 0;
  }
</style>
